export const attendee = '/MersetaInternalAttendee';
export const allocatedAttendees = attendee + '/AllocatedAttendees/';
export const getAllUnassociatedAttendee = attendee + '/AllUnassociatedAttendee/';